import { Link } from 'react-router-dom';
import Text from '@ui/text/text/text';
import Segments from './segments';
import Container from '@ui/container/container';
import ProjectColorText from '@ui/text/text/project-color-text';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import styles from './project-overview-segments.module.css';

const ProjectOverviewSegments = () => {
  return (
    <Container data-component="ProjectOverviewSegments" className={styles.wrapper}>
      <Container className="flex-column gap-8" padding="0 var(--main-content-horizontal-padding)">
        <Container className="flex fd-row jc-space-between ai-center" data-component="ProjectOverviewSegmentsHeader">
          <Text tag="h5" className="H5" design="GlobalIcoText1">
            Segments
          </Text>
          <Link to="segments" data-component="EditSegmentsLink">
            <ProjectColorText
              contrastAgainstAppBackground
              data-component="EditTextWrapper"
              colorVariable={EColorVariablesV2.primary}
              className="L1 cursor-pointer"
            >
              Edit Segments
            </ProjectColorText>
          </Link>
        </Container>
        <Link to="segments">
          <Segments appName="platform-overview" />
        </Link>
      </Container>
    </Container>
  );
};

export default ProjectOverviewSegments;
